import React from 'react';
import PropTypes from 'prop-types';

function LastFilingTooltip({ date }) {
  return (
    <div className="messages status missing-entries-tooltip">
      Last filing was on {date}, you can update dockets for more recent filings.
    </div>
  );
}

LastFilingTooltip.propTypes = {
  date: PropTypes.string.isRequired,
};

export default LastFilingTooltip;



// WEBPACK FOOTER //
// ./src/components/case/docket/LastFilingTooltip.jsx